import { Component, OnInit } from '@angular/core';
import { TaskComponent } from '../task/task.component';

@Component({
  selector: 'app-task-flashcard-terms',
  templateUrl: './task-flashcard-terms.component.html',
  styleUrls: ['./task-flashcard-terms.component.css']
})
export class TaskFlashcardTermsComponent extends TaskComponent {

  ngOnInit() {
  }

}
